// Spanish translation

const es = {
  "hotel.folio.no_guest": "Sin Huesped",
  "hotel.folio.registration_card.report": "Tarjeta de Registro",
};

export default es;
